import styled, { css } from 'styled-components';

const theme = {
	color: {
		accent: '#4361EE',
		accent_hover: '#2D4AD1',
		bg_light: '#EAF1FF',
		heading: '#3B3F5C',
		content: '#757575',
		link: '#4361EE',
		link_hover: '#2D4AD1',
	}
}

export const Heading = styled.div`
	font-size: 48px;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 25px;
	color: ${theme.color.heading};

	${props => props.h2 && `
		font-weight: 500;
		font-size: 32px;
		line-height: 37px;
		margin-bottom: 30px;
    `}

	${props => props.h3 && `
		font-weight: 500;
		font-size: 25px;
		line-height: 1.3;
    `}

	${props => props.mb2 && `
        margin-bottom: 2em;
    `}

    ${props => props.i && `
        font-style: italic;
    `}
`;


export const H1 = styled.h1`
	font-size: 48px;
    font-weight: 500;
    line-height: 1;
    margin: 0 0 25px 0;
	color: ${theme.color.heading};
`;

export const H2 = styled.h2`
	margin-bottom: 30px;

	font-weight: 500;
	font-size: 27px;
	line-height: 32px;
	color: #3B3F5C;
`;

export const H3 = styled.h3`
    font-weight: 500;
	color: ${theme.color.heading};
	font-size: 25px;
	line-height: 1.3;
`;

export const H4 = styled.h4`
	font-weight: 500;
	font-size: 19px;
	line-height: 22px;
	color: ${theme.color.heading};
`;


export const P = styled.p`
	font-size: 18px;
    color: #353852;
	margin: 0 0 45px 0;
    line-height: 1.5;
    font-weight: 400;

    ${props => props.i && `
        font-style: italic;
    `}

    ${props => props.b && `
        font-weight: bold;
    `}
`;

export const Row = styled.div`
	display: ${props => props.hidden ? "none" : "flex"};
    justify-content: space-between;
	${props => props.maxHeight && `
		max-height: ${props.maxHeight}px;
	`}
`

export const Col = styled.div`
    width: 50%;
	${props => props.width && `
        width: ${props.width};
    `}
`

export const Button = styled.button`
	color: #fff;
    border: none;
    margin-top: 1em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    background: ${theme.color.accent};
    border-radius: 2px;
    margin: 0;
	cursor: pointer;
	line-height: 1;
	font-size: 16px;
    padding: 14px 32px;
	transition: background 200ms ease-in-out;

	&:hover {
		background: ${theme.color.accent_hover};
	}

	&:focus {
		outline: none;
	}

	svg {
		fill: #fff;
	}

	${props => props.before && `
        svg {
            margin: 0 12px ​0 0;
        }
    `}

    ${props => props.after && `
        svg {
			margin: 0 0 0 12px;
        }
    `}

    ${props => props.ml1 && `
        margin-left: 1em;
    `}

	${props => props.type &&
		'primary' == props.type && `
		background: #2271b1;
    `}

	${props => props.type &&
		'secondary' == props.type && `
		background: #f6f7f7;
		color: #2271b1;
		border-color: #2271b1;
    `}

`;

export const Progress = styled.progress`
    width: 100%;
`;

export const Spacer = styled.div`
	padding: 1em;
	${props => props.p2 && `
		padding: 2em;
	`}
	${props => props.p3 && `
		padding: 3em;
	`}
	${props => props.p4 && `
		padding: 4em;
	`}
`;

export const Link = styled.span`
	cursor: pointer;
	color: #757575;

	svg {
		fill: #757575;
	}

	&:hover {
		color: #2D4AD1;

		svg {
			fill: #2D4AD1;
		}
	}

	${props => props.before && `
		svg {
			margin-right: 10px;
		}
	`}

	${props => props.after && `
		svg {
			margin-left: 10px;
		}
	`}
`;

export const Label = styled.span`
	font-weight: bold;
	font-size: 1rem;
	margin-bottom: .5em;
	display: block;
`;
